import React, { useState } from 'react';
import {
  SafeAreaView, StatusBar, StyleSheet, View, ActivityIndicator, Text,
} from 'react-native';
import { Avatar, TextInput } from 'react-native-paper';
import { useSelector, useDispatch } from 'react-redux';
import * as ImagePicker from 'expo-image-picker';
import userActions from '../actions/userActions';
import Header from '../components/Header';
import StatusTypes from '../store/types';
import GradientButton from '../components/GradientButton';
import APMStyles from '../styles';
import Theme from '../constants/Theme';

function Profile({ navigation }) {
  const user = useSelector((state) => state.user);
  const { status, error } = user;
  const dispatch = useDispatch();

  const { email } = user.user.attributes;
  const [nickname, setNickname] = useState(user.user.attributes.nickname || '');
  const [height, setHeight] = useState(user.user.attributes['custom:height'] || '');
  const [weight, setWeight] = useState(user.user.attributes['custom:weight'] || '');

  function saveUser() {
    dispatch(userActions.updateUser({
      nickname, height, weight,
    }));
  }

  async function uploadImg() {
    const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      alert('Permission to access camera roll is required');
      return;
    }
    const pickerResult = await ImagePicker.launchImageLibraryAsync();
    console.log(pickerResult);
    if (pickerResult.cancelled) {
      return;
    }
    dispatch(userActions.updateUserImg({
      picture: pickerResult,
      userid: user.user.attributes.sub,
    }));
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" />
      <Header style={styles.header} navigation={navigation} />

      <View style={styles.body}>
        {status === StatusTypes.updateUserFail && (
        <Text testID="update-error-msg" style={styles.status}>
          Update failed:
          {' '}
          {error.message}
        </Text>
        )}
        {status === StatusTypes.updateUserPending && <ActivityIndicator testID="loading-indicator" />}
        {status === StatusTypes.updateUserSuccess && <Text testID="update-success-msg" style={styles.status}>Update success</Text>}

        <View style={styles.userImgContainer}>
          {
            user.user.attributes.picture
              ? (
                <Avatar.Image
                  size={100}
                  source={{ uri: user.user.attributes.picture }}
                  theme={Theme.avatar}
                />
              ) : <Avatar.Icon size={100} icon="account-circle-outline" />
          }
          <GradientButton
            onPress={uploadImg}
            testID="upload-img-btn"
            outline
            style={styles.uploadBtn}
          >
            UPLOAD IMAGE
          </GradientButton>
        </View>

        <TextInput
          label="EMAIL"
          mode="outlined"
          value={email}
          disabled
          theme={Theme.textInput}
          left={<TextInput.Icon name="email-outline" />}
          style={styles.textInput}
        />

        <TextInput
          label="NICKNAME"
          mode="outlined"
          value={nickname}
          onChangeText={(text) => setNickname(text)}
          testID="nickname-input"
          theme={Theme.textInput}
          left={<TextInput.Icon name="account-box-outline" />}
          style={styles.textInput}
        />

        <TextInput
          label="HEIGHT"
          mode="outlined"
          value={height}
          onChangeText={(text) => setHeight(text)}
          testID="height-input"
          theme={Theme.textInput}
          left={<TextInput.Icon name="human-male-height" />}
          right={<TextInput.Affix text="in" />}
          style={styles.textInput}
        />

        <TextInput
          label="WEIGHT"
          mode="outlined"
          value={weight}
          onChangeText={(text) => setWeight(text)}
          testID="weight-input"
          theme={Theme.textInput}
          left={<TextInput.Icon name="weight" />}
          right={<TextInput.Affix text="lb" />}
          style={styles.textInput}
        />

        <GradientButton
          onPress={saveUser}
          testID="save-profile-btn"
          disabled={status === StatusTypes.updateUserPending}
          style={styles.button}
        >
          SAVE
        </GradientButton>
        <GradientButton outline style={styles.button}>CHANGE PASSWORD</GradientButton>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: APMStyles.colors.background,
    flex: 1,
  },
  header: {
    flex: 1,
  },
  body: {
    flex: 11,
    justifyContent: 'center',
    paddingHorizontal: '20%',
  },
  status: {
    color: APMStyles.colors.text,
  },
  userImgContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 10,
  },
  uploadBtn: {
    paddingLeft: 10,
  },
  textInput: {
    paddingBottom: 10,
  },
  button: {
    paddingBottom: 10,
    marginTop: 6,
  },
});

export default Profile;
